/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '@angular/router';
import * as i2 from '@angular/common';
import * as i3 from '../../../app/shared/breadcrumb.component';
const styles_BreadcrumbsComponent:any[] = ([] as any[]);
export const RenderType_BreadcrumbsComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_BreadcrumbsComponent,data:{}});
function View_BreadcrumbsComponent_3(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),2,'a',([] as any[]),
      [[1,'target',0],[8,'href',4]],[[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('click' === en)) {
          const pd_0:any = ((<any>i0.ɵnov(_v,1).onClick($event.button,$event.ctrlKey,
              $event.metaKey,$event.shiftKey)) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },(null as any),(null as any))),i0.ɵdid(1,671744,(null as any),0,i1.RouterLinkWithHref,
      [i1.Router,i1.ActivatedRoute,i2.LocationStrategy],{routerLink:[0,'routerLink']},
      (null as any)),(_l()(),i0.ɵted(2,(null as any),['','']))],(_ck,_v) => {
    const currVal_2:any = (<any>(<any>_v.parent).parent).context.$implicit.url;
    _ck(_v,1,0,currVal_2);
  },(_ck,_v) => {
    const currVal_0:any = i0.ɵnov(_v,1).target;
    const currVal_1:any = i0.ɵnov(_v,1).href;
    _ck(_v,0,0,currVal_0,currVal_1);
    const currVal_3:any = (<any>(<any>_v.parent).parent).context.$implicit.label.title;
    _ck(_v,2,0,currVal_3);
  });
}
function View_BreadcrumbsComponent_4(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),2,'span',([] as any[]),
      (null as any),[[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('click' === en)) {
          const pd_0:any = ((<any>i0.ɵnov(_v,1).onClick()) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },(null as any),(null as any))),i0.ɵdid(1,16384,(null as any),0,i1.RouterLink,
      [i1.Router,i1.ActivatedRoute,[8,(null as any)],i0.Renderer2,i0.ElementRef],{routerLink:[0,
          'routerLink']},(null as any)),(_l()(),i0.ɵted(2,(null as any),['','']))],
      (_ck,_v) => {
        const currVal_0:any = (<any>(<any>_v.parent).parent).context.$implicit.url;
        _ck(_v,1,0,currVal_0);
      },(_ck,_v) => {
        const currVal_1:any = (<any>(<any>_v.parent).parent).context.$implicit.label.title;
        _ck(_v,2,0,currVal_1);
      });
}
function View_BreadcrumbsComponent_2(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),9,'li',[['class',
      'breadcrumb-item']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),i0.ɵdid(1,278528,(null as any),0,i2.NgClass,[i0.IterableDiffers,
      i0.KeyValueDiffers,i0.ElementRef,i0.Renderer],{klass:[0,'klass'],ngClass:[1,
      'ngClass']},(null as any)),i0.ɵpod(2,{active:0}),(_l()(),i0.ɵted(-1,(null as any),
      ['\n        '])),(_l()(),i0.ɵand(16777216,(null as any),(null as any),1,(null as any),
      View_BreadcrumbsComponent_3)),i0.ɵdid(5,16384,(null as any),0,i2.NgIf,[i0.ViewContainerRef,
      i0.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),(_l()(),i0.ɵted(-1,(null as any),
      ['\n        '])),(_l()(),i0.ɵand(16777216,(null as any),(null as any),1,(null as any),
      View_BreadcrumbsComponent_4)),i0.ɵdid(8,16384,(null as any),0,i2.NgIf,[i0.ViewContainerRef,
      i0.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),(_l()(),i0.ɵted(-1,(null as any),
      ['\n    ']))],(_ck,_v) => {
    const currVal_0:any = 'breadcrumb-item';
    const currVal_1:any = _ck(_v,2,0,(<any>_v.parent).context.last);
    _ck(_v,1,0,currVal_0,currVal_1);
    const currVal_2:boolean = !(<any>_v.parent).context.last;
    _ck(_v,5,0,currVal_2);
    const currVal_3:any = (<any>_v.parent).context.last;
    _ck(_v,8,0,currVal_3);
  },(null as any));
}
function View_BreadcrumbsComponent_1(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵted(-1,(null as any),['\n        '])),(_l()(),i0.ɵand(16777216,
      (null as any),(null as any),1,(null as any),View_BreadcrumbsComponent_2)),i0.ɵdid(2,
      16384,(null as any),0,i2.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i0.ɵand(0,(null as any),(null as any),0))],
      (_ck,_v) => {
        const currVal_0:any = _v.context.$implicit.label.title;
        _ck(_v,2,0,currVal_0);
      },(null as any));
}
export function View_BreadcrumbsComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵted(-1,(null as any),['\n    '])),(_l()(),i0.ɵand(16777216,
      (null as any),(null as any),1,(null as any),View_BreadcrumbsComponent_1)),i0.ɵdid(2,
      802816,(null as any),0,i2.NgForOf,[i0.ViewContainerRef,i0.TemplateRef,i0.IterableDiffers],
      {ngForOf:[0,'ngForOf']},(null as any))],(_ck,_v) => {
    var _co:i3.BreadcrumbsComponent = _v.component;
    const currVal_0:any = _co.breadcrumbs;
    _ck(_v,2,0,currVal_0);
  },(null as any));
}
export function View_BreadcrumbsComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'breadcrumbs',
      ([] as any[]),(null as any),(null as any),(null as any),View_BreadcrumbsComponent_0,
      RenderType_BreadcrumbsComponent)),i0.ɵdid(1,114688,(null as any),0,i3.BreadcrumbsComponent,
      [i1.Router,i1.ActivatedRoute],(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const BreadcrumbsComponentNgFactory:i0.ComponentFactory<i3.BreadcrumbsComponent> = i0.ɵccf('breadcrumbs',
    i3.BreadcrumbsComponent,View_BreadcrumbsComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// C:/Source/eSoftCereal.API/eSoftCereal.UI/src/$$_gendir/app/shared/breadcrumb.component.ngfactory.ts